import { Button, Input } from '@cokitchen/cokitchen-components';
import AddressInput from 'components/base/address-input';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { AddressFormatType } from 'models/address.model';
import { LocationObjectType } from 'models/location.model';
import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import bulkOrderService from 'services/bulk-order.service';
import { handleApiError } from 'utils/functions';
type Props = {
  isOpen: boolean;
  onClose: () => void;
  activeAddress?: LocationObjectType;
  setActiveAddress?: (item: LocationObjectType) => void;
};
const EditSavedAddressModal = ({ isOpen, onClose, activeAddress, setActiveAddress }: Props) => {
  const { refetchSavedAddressList } = useDashboardContext();

  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeAddress) {
      setValue(activeAddress.address);
    }
  }, [activeAddress]);

  const handleClose = () => {
    setValue(activeAddress?.address ?? '');
    onClose();
  };

  const editAddress = async (address: AddressFormatType) => {
    setLoading(true);
    try {
      await apiService.put(`user-saved-address`, {
        baseURL: process.env.REACT_APP_CORE_API_URL,
        data: {
          id: activeAddress?.id,
          ...address
        }
      });
      await refetchSavedAddressList();
    } catch (err) {
      handleApiError(err, 'Error saving address');
    } finally {
      setLoading(false);
    }
  };

  const handleEditAddress = async () => {
    try {
      const formattedAddress = await bulkOrderService.FormatAddress(
        value,
        activeAddress?.name ?? ''
      );

      await editAddress(formattedAddress);
    } catch (error) {
      console.log(error);
    } finally {
      onClose();
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={() => {
        handleClose();
      }}
      title='Edit address'>
      <div className='w-full'>
        <Input
          design='bordered'
          type='text'
          label='Location tag'
          optional
          placeholder='e.g Branch 1'
          className='mb-3'
          value={activeAddress?.name}
          onChange={(e) => {
            if (activeAddress) {
              setActiveAddress?.({
                ...activeAddress,
                name: e.target.value
              });
            }
          }}
        />

        <AddressInput
          label='Address'
          placeholder='Enter address'
          value={value}
          onChange={setValue}
        />
        <div className='w-full flex gap-4 justify-end'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={() => {
              handleClose();
            }}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            disabled={!value}
            loading={loading}
            onClick={handleEditAddress}>
            Save
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default EditSavedAddressModal;
